<div class="surface-card p-3 border-round">
  <div class="flex flex-column md:flex-row align-items-start md:align-items-center justify-content-between mb-3">
    <div class="flex align-items-center gap-3 mb-2 md:mb-0">
      <div class="text-xl font-medium">Cost Details</div>
        <app-settlement-status [status]="costs?.status" class="ml-2"></app-settlement-status>
    </div>
    <p-button
      label="Enter Course Refund Details"
      icon="pi pi-pencil"
      styleClass="p-button-outlined p-button-primary p-button-sm"
      [disabled]="costs?.status !== SettlementStatus.REFUND_PENDING"
      (click)="onEnterRefundDetails()">
    </p-button>
  </div>

  <p-divider class="my-2"></p-divider>
  <!-- Section 1: Core Costs -->
  <div class="flex gap-5">
    <div class=" flex flex-column gap-3" style="min-width: 15rem">
      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center">
          <i class="pi pi-tag mr-1 text-primary"></i>
          <span class="text-xs text-color-secondary">Green Fee:</span>
        </div>
        <div class="text-right">
          <span class="font-medium">{{costs?.greenfee || 0 | number}} × {{golfer || 0}} = {{getGreenfeeTotal() | number}}</span>
        </div>
      </div>

      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center">
          <i class="pi pi-car mr-1 text-primary"></i>
          <span class="text-xs text-color-secondary">Cart Fee:</span>
        </div>
        <div class="text-right">
          <span class="font-medium">{{costs?.cart || 0 | number}} × {{cart || 0}} = {{getCartTotal() | number}}</span>
        </div>
      </div>

      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center">
          <i class="pi pi-user mr-1 text-primary"></i>
          <span class="text-xs text-color-secondary">Caddy Fee:</span>
        </div>
        <div class="text-right">
          <span class="font-medium">{{costs?.caddy || 0 | number}} × {{caddy || 0}} = {{getCaddyTotal() | number}}</span>
        </div>
      </div>
    </div>
    <div class=" flex flex-column gap-3" style="min-width: 15rem">
      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center">
          <i class="pi pi-percentage mr-1 text-primary"></i>
          <span class="text-xs text-color-secondary">VAT:</span>
        </div>
        <span class="font-medium">{{costs?.vat || 0 | number}}</span>
      </div>

      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center">
          <i class="pi pi-percentage mr-1 text-primary"></i>
          <span class="text-xs text-color-secondary">Withholding Tax:</span>
        </div>
        <span class="font-medium">{{costs?.wt || 0 | number}}</span>
      </div>

      <div class="flex justify-content-between">
        <div class="font-medium text-primary">Initial Cost:</div>
        <div class="font-medium text-primary">{{getInitialCost() | number}}</div>
      </div>
    </div>
  </div>

  <p-divider class="my-2"></p-divider>
  <!-- Section 2: Discounts & Adjustments -->
  <div class="grid">
    <div class="col-12">
      <p class="text-sm font-medium mb-1 text-primary">Discounts & Adjustments</p>
    </div>

    <div class="col-12 md:col-3 mb-2">
      <div class="flex align-items-center gap-2">
        <div class="flex align-items-center">
          <i class="pi pi-wallet mr-1 text-green-500"></i>
          <span class="text-xs text-color-secondary">Credit:</span>
        </div>
        <span class="font-medium text-green-500">{{costs?.useCreditAmount | textNumber: '-'}}</span>
      </div>
    </div>

    <div class="col-12 md:col-3 mb-2">
      <div class="flex align-items-center gap-2">
        <div class="flex align-items-center">
          <i class="pi pi-ticket mr-1 text-green-500"></i>
          <span class="text-xs text-color-secondary">Coupon:</span>
        </div>
        <span class="font-medium text-green-500">{{costs?.couponTotalDiscount | textNumber: '-'}}</span>
      </div>
    </div>

    <div class="col-12 md:col-3 mb-2" >
      <div class="flex align-items-center gap-2">
        <div class="flex align-items-center">
          <i class="pi pi-plus-circle mr-1 text-green-500"></i>
          <span class="text-xs text-color-secondary">Additional:</span>
        </div>
        <span class="font-medium text-green-500">{{costs?.additionalCost | textNumber: '-'}}</span>
      </div>
    </div>
  </div>

  <p-divider class="my-2"></p-divider>

  <!-- Section 3: Transfer Info -->
  <div class="grid">
    <div class="col-12">
      <p class="text-sm font-medium mb-1 text-primary">Transfer Information</p>
    </div>

    <div class="col-6 md:col-3 mb-2">
      <div class="flex align-items-center">
        <i class="pi pi-credit-card mr-1 text-primary"></i>
        <span class="text-xs text-color-secondary mr-1">Type:</span>
        <span class="font-medium">{{costs?.settlementType}}</span>
      </div>
    </div>

    <div class="col-6 md:col-3 mb-2">
      <div class="flex align-items-center">
        <i class="pi pi-calendar mr-1 text-primary"></i>
        <span class="text-xs text-color-secondary mr-1">Scheduled:</span>
        <span class="font-medium underline text-primary cursor-pointer" (click)="navigateToTransferPage()">{{costs?.transferScheduledDate | date:'dd MMM yy'}}</span>
      </div>
    </div>

    <div class="col-6 md:col-3 mb-2">
      <div class="flex align-items-center">
        <i class="pi pi-calendar-check mr-1 text-primary"></i>
        <span class="text-xs text-color-secondary mr-1">Transferred:</span>
        <span class="font-medium">{{costs?.transferDate ? (costs?.transferDate | date:'dd MMM yy') : '-'}}</span>
      </div>
    </div>

    <div class="col-6 md:col-3 mb-2">
      <div class="flex align-items-center">
        <i class="pi pi-money-bill mr-1 text-green-500"></i>
        <span class="text-xs text-color mr-1">Amount:</span>
        <span class="font-medium">{{costs?.transferAmount | textNumber: '-' }}</span>
      </div>
    </div>
  </div>

  <p-divider class="my-2"></p-divider>

  <!-- Section 4: Refund Info -->
  <div class="grid">
    <div class="col-12">
      <p class="text-sm font-medium mb-1 text-primary">Refund Information</p>
    </div>

    <div class="col-6 md:col-3 mb-2">
      <div class="flex align-items-center">
        <i class="pi pi-calendar mr-1 text-primary"></i>
        <span class="text-xs text-color-secondary mr-1">Refund Date:</span>
        <span class="font-medium">{{costs?.refundAt ? (costs?.refundAt | date:'dd MMM yy') : '-'}}</span>
      </div>
    </div>

    <div class="col-6 md:col-3 mb-2">
      <div class="flex align-items-center">
        <i class="pi pi-ticket mr-1 text-primary"></i>
        <span class="text-xs text-color-secondary mr-1">Refund Coupon:</span>
        <span class="font-medium">{{costs?.refundCoupon | textNumber: '-'}}</span>
      </div>
    </div>

    <div class="col-6 md:col-3 mb-2">
      <div class="flex align-items-center">
        <i class="pi pi-wallet mr-1 text-primary"></i>
        <span class="text-xs text-color-secondary mr-1">Refund Credit:</span>
        <span class="font-medium">{{costs?.refundCreditAmount | textNumber: '-'}}</span>
      </div>
    </div>
  </div>
</div>

